import React from 'react';
import Title from './Title';
import {ProductConsumer} from '../Context/Context';
import {Link } from 'react-router-dom';
import {scroller} from 'react-scroll';
import ContactUs from '../ContactUs/ContactUs';




export default function Contact() {


    const scrollToElement=(element)=>{
        scroller.scrollTo(element,{
    
         duration:1500,
         delay:100,
         smooth:true,
         offset:-80
    
    
        })
    }




    return (
<ProductConsumer>
{value=>{
    const {setClass}=value;
    return(
    <React.Fragment>
        <Title  title="Contact" color={setClass?"#fefefe":"gray"} /> 
<div className={setClass?"dark-mode-blue contact":"contact"}>
<div className="container">
<ContactUs /><br /><br />
    <div className="contact-center">
        <div className="contact-links">
            <h3 className={setClass?"dark-mode-orange ":" "}>LINKS</h3> 
            <div className="links-items">
     
               {value.links.map(item=>{
                   return(
                       <li key={item.id}>
                       <Link to="/" onClick={()=>scrollToElement(item.scrolling)}>{item.link}</Link>

                       </li>
                   )
               })} 
            </div>

        </div>

        <div className="contact-media">

        
            <h3 className={setClass?"dark-mode-orange ":" "}>MEDIA</h3>
            <div className="media-items">
                {/* <li><a href="https://www.youtube.com/channel/UCLSCq6wNL8QHrAl9XHEm3YQ?view_as=subscriber" target="_blank" rel="noopener noreeferrer" ><i className="fab fa-youtube-square"></i>Youtube</a></li> */}

                <li> <a href="https://www.instagram.com/ceo_mr.nagendra_baithwar/" target="_blank" rel="noopener noreeferrer" ><i className="fab fa-instagram"></i>Instagram</a>
                </li>

                <li> <a href="https://www.facebook.com/nagendra.baithwar.7" target="_blank" rel="noopener noreeferrer" ><i className="fab fa-facebook-square"></i>Facebook</a></li>

                {/* <li> <a href="https://twitter.com/NileshShriwas3" target="_blank" rel="noopener noreeferrer" ><i className="fab fa-twitter"></i>Twitter</a></li> */}
            </div>
        </div>
    </div>
</div>
</div>

<div className={setClass?"dark-mode-blue created":"created"}>
    <div className="container">
            <p>© Bwarr Buildcon And Property Solutions {year()>2020 ?"2019 - ":""}{year()}</p>
    </div>
</div>
    </React.Fragment>
    )
}}
</ProductConsumer>
    )
}

// year function
let year = ()=>{
    let year = new Date().getFullYear();
    return year
}